import { Injectable } from '@angular/core';
import { AuthAdapter } from './auth-adapter';
import { LocalStorageService } from '../../../services/local-storage.service';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { UserModel } from '../models/user.model';
import { CryptoService } from '../../../services/crypto.service';
import { map } from 'rxjs/internal/operators';

@Injectable({
  providedIn: 'root'
})
export class Oauth2 implements AuthAdapter {
  public dataKey = 'tokenObject';
  public user;

  constructor(private http: HttpClient, private localStorage: LocalStorageService, private cryptoService: CryptoService) {
  }

  private getTokenObject() {
    return this.cryptoService.decrypt(this.localStorage.getItem(this.dataKey));
  }

  private setTokenObject(data) {
    this.localStorage.setItem(this.dataKey, this.cryptoService.encrypt(data));
  }

  public login(data) {
    const params = Object.assign({}, data, {
      client_id: environment['auth']['settings']['client_id'],
      client_secret: environment['auth']['settings']['client_secret'],
      grant_type: environment['auth']['settings']['grant_type'],
    });

    return this.http.post(environment['auth']['settings']['tokenUrl'], params).toPromise().then((response) => {
      if (response['access_token']) {
        response['username'] = data['username'];
        this.setTokenObject(response);
        return Promise.resolve(true);
      }
      return Promise.resolve(false);
    });
  }

  public logout() {
    this.localStorage.removeItem(this.dataKey);
    return Promise.resolve(true);
  }

  public isAuthenticated() {
    return !!this.localStorage.getItem(this.dataKey);
  }

  public getUserInfo() {
    const authParams = this.getAuthParams();
    return this.http.get(environment['auth']['settings']['userInfoUrl'] + authParams)
      .pipe(map(res => this.user = new UserModel(res)));
  }

  public getAuthParams() {
    return '?Context[Identity][UserType]=' +
      environment['auth']['settings']['user_type'] + '&Context[Identity][Username]=' + this.getTokenObject()['username'];
  }

  public getToken() {
    return this.getTokenObject()['access_token'];
  }

  public getUsername() {
    return this.getTokenObject()['username'];
  }
}
